import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Grid, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Input } from 'components/FormInputs';
import { useFormik } from 'components/shared/Formik';

const LANGS = {
  sv: <FormattedMessage id="SwedishDescription" defaultMessage="Swedish description (optional)" />,
  en: <FormattedMessage id="EnglishDescription" defaultMessage="English description (optional)" />,
  de: <FormattedMessage id="GermanDescription" defaultMessage="German description (optional)" />,
};

const EditDialog = ({ onSubmit, onClose, onDelete, images, edit }) => {
  const image = images.find((v, i) => edit === i);
  const formik = useFormik({
    initialValues: {
      comment_sv: '',
      comment_en: '',
      comment_de: '',
      ...image,
    },
    validateOnBlur: true,
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const { comment_de, comment_en, comment_sv } = values;

      onSubmit({ comment_de, comment_en, comment_sv });
    },
  });

  const { values, handleChange, handleSubmit, errors, handleBlur } = formik;

  return (
    <Dialog onClose={onClose} open fullWidth maxWidth="md">
      <form onSubmit={handleSubmit} noValidate>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <img src={`/img/${image.filename}?w=800&h=800&fit=crop`} alt="img" />
            </Grid>
            <Grid item xs={12} md={8}>
              {Object.keys(LANGS).map((lang) => (
                <div key={lang}>
                  <Input
                    name={`comment_${lang}`}
                    value={values[`comment_${lang}`]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors}
                    label={LANGS[lang]}
                  />
                </div>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            aria-label="Delete"
            color="secondary"
            onClick={() => onDelete()}
            type="button"
            style={{ marginTop: '8px', marginRight: '8px' }}
          >
            <FormattedMessage id="Delete image" defaultMessage="Delete image" />
          </Button>
          <Button
            aria-label="Ok"
            color="primary"
            type="submit"
            style={{ marginTop: '8px', marginRight: '8px' }}
          >
            <FormattedMessage id="Ok" defaultMessage="Ok" />
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EditDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({})),
  edit: PropTypes.number.isRequired,
};

export default EditDialog;
